import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import { FaPlus, FaCheck, FaTimes, FaTrashAlt, FaEdit } from "react-icons/fa";

const CountySelector = ({
  stateAndCounties,
  selectedCountyName,
  onCountyChange,
  onSaveCounty,
  onDeleteCounty,
  onAddCounty,
  isLoading,
  taxState,
  styles,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [isAdding, setIsAdding] = useState(false);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    if (!isAdding) {
      setInputValue(selectedCountyName);
    }
  }, [selectedCountyName, isAdding]);

  const handleSave = () => {
    if (isAdding) {
      if (!inputValue.trim()) return;
      onAddCounty({ county: inputValue });
      setIsAdding(false);
    } else {
      onSaveCounty({
        county: inputValue,
        isDeleted: false,
      });
      setIsEditing(false);
    }
  };

  const handleDelete = () => {
    if (
      window.confirm(
        `Delete county "${selectedCountyName}"? This cannot be undone.`,
      )
    ) {
      onDeleteCounty({ isDeleted: true });
      setIsEditing(false);
    }
  };

  const handleCancel = () => {
    setIsEditing(false);
    setIsAdding(false);
    setInputValue(selectedCountyName);
  };

  const handleStartAdd = () => {
    setIsAdding(true);
    setIsEditing(false);
    setInputValue("");
  };

  const handleStartEdit = () => {
    setIsEditing(true);
    setIsAdding(false);
    setInputValue(selectedCountyName);
  };

  return (
    <div className={styles.formGroup}>
      <label className={styles.label}>
        County <span className={styles.required}>*</span>
      </label>
      <div className={styles.inputWithButton}>
        {isEditing || isAdding ? (
          <Form.Control
            type="text"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            className={styles.input}
            placeholder={isAdding ? "Enter new county" : "County name"}
            autoFocus
          />
        ) : (
          <Form.Control
            as="select"
            onChange={(e) => onCountyChange(e.target.value)}
            value={selectedCountyName}
            className={styles.select}
            disabled={!taxState || isLoading}
          >
            <option value="">Choose county...</option>
            {stateAndCounties.map((countyItem, index) => (
              <option
                key={countyItem.countyId || index}
                value={countyItem.county}
              >
                {countyItem.county}
              </option>
            ))}
          </Form.Control>
        )}

        <div className={styles.buttonGroup}>
          {isEditing || isAdding ? (
            <>
              <button
                className={styles.buttonSuccess}
                onClick={handleSave}
                disabled={isLoading || !inputValue.trim()}
                title="Save"
              >
                <FaCheck />
              </button>
              <button
                className={styles.buttonWarning}
                onClick={handleCancel}
                title="Cancel"
              >
                <FaTimes />
              </button>
              {isEditing && (
                <button
                  className={styles.buttonDanger}
                  onClick={handleDelete}
                  disabled={isLoading}
                  title="Delete"
                >
                  <FaTrashAlt />
                </button>
              )}
            </>
          ) : (
            <>
              <button
                className={styles.buttonPrimary}
                onClick={handleStartAdd}
                disabled={!taxState || isLoading}
                title="Add New County"
              >
                <FaPlus />
              </button>
              {selectedCountyName && (
                <button
                  className={styles.buttonOutline}
                  onClick={handleStartEdit}
                  disabled={isLoading}
                  title="Edit County Name"
                >
                  <FaEdit />
                </button>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CountySelector;
